import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  cover: string;
  category: string;
  summary: string;
  author: string;
  date: string;
  views: number;
}

export default function ArticleCard({ id, title, cover, category, summary, author, date, views }: ArticleCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return (v / 10000).toFixed(1) + '万';
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative w-full sm:w-48 aspect-video sm:aspect-[4/3] rounded-lg overflow-hidden shrink-0">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500 text-white text-xs font-medium">
          {category}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-base font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
          {title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {summary}
        </p>
        <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
          <span>{author}</span>
          <span>{date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(views)}
          </span>
        </div>
      </div>
    </Link>
  );
}